<template>
  <div class="servicepopup">
    <el-dialog :visible.sync="visible" :show-close="false" width="860px">
      <div class="content">
        <img :src="url"  class="img">
        <img
          src="@/assets/image/close2.webp"
          class="close"
          alt=""
          srcset=""
          @click="visible = false"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      visible:false,
      url:''
    };
  },
  created() {},
  computed: {

  },
  methods: {
   onShow(url){
    this.url = url
    this.visible = true;
   },
   onHide(){
    this.visible = false;
   }

  },
};
</script>

<style scoped lang="scss">
.servicepopup {
  @include popupNo;
  &::v-deep .el-dialog {
    border-radius: 20px;
  }
}
.content {
  width: 860px;
 
  position: relative;
  .img{
    width: 860px;
    height: auto;
    vertical-align: middle;
  }
  .close {
    width: 28px;
    height: 28px;
    position: absolute;
    bottom: -48px;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
}
</style>
